import {
  type ContractAnalysisRow,
  Mtds,
  ReviewCombinationModal
} from 'prove-common'
import { useState } from 'react'

export type ReviewCardProps = {
  row: ContractAnalysisRow
}

export const ReviewCard = ({ row }: ReviewCardProps) => {
  const [isOpen, setOpen] = useState(false)
  const { status, analysisType } = row

  if (status === 'awaiting') {
    return (
      <Mtds.Alert data-color='warning' as={Mtds.Prose}>
        <p>
          This combination is awaiting review. Approving it allows Mattilsynet
          to send requisitions to your lab with this combination. Declining
          requires a written reason. If Mattilsynet later updates the
          combination, the status resets and a new review is required.
        </p>
        <Mtds.Button
          data-variant='primary'
          data-color={'main'}
          onClick={() => setOpen(true)}
        >
          Review combination
        </Mtds.Button>
        <ReviewCombinationModal
          id='review-combination-detail-modal'
          review={isOpen ? [row] : undefined}
          onClose={() => setOpen(false)}
        />
      </Mtds.Alert>
    )
  }

  return (
    <Mtds.Alert data-color={status === 'approved' ? 'success' : 'danger'}>
      <p>
        This combination has been <strong>{status}</strong>
        {analysisType.approvalComment != null &&
          `: "${analysisType.approvalComment}"`}
        .
      </p>
    </Mtds.Alert>
  )
}
